@if (hasLocation()) {
  @if (allTasksCompleted()) {
    <!-- Completed State -->
    <div
      class="tw-w-full tw-max-w-[496px] tw-mx-auto tw-flex-col tw-bg-dt-surface-card tw-rounded-3xl"
    >
      <div class="tw-flex tw-flex-col tw-items-center tw-gap-3 tw-py-4 tw-translate-x-2">
        <icon [name]="'congratulation'" [size]="20" [currentColor]="'primary'"></icon>

        <div class="tw-text-2xl tw-font-bold tw-text-dt-text-headings">
          {{ "congratulations" | i18n }}
        </div>

        <div class="tw-text-[14px] tw-text-dt-text-tertiary tw-text-center tw-max-w-[360px]">
          {{ "guideCompletedMessage" | i18n }}
        </div>
      </div>

      <div class="tw-px-1">
        <div
          class="tw-bg-dt-information-100 tw-border tw-border-dt-information-300 tw-rounded-3xl tw-p-3 tw-flex tw-items-start tw-gap-3"
        >
          <icon [name]="'info-tooltip'" [size]="7" [currentColor]="'dt-information-500'"></icon>
          <!-- Content -->
          <div class="tw-flex tw-flex-col tw-gap-1">
            <div class="tw-text-[14px] tw-font-bold tw-text-dt-information-500">
              {{ "whereIsTheGuide" | i18n }}
            </div>

            <div
              class="tw-text-[13px] tw-font-semibold tw-leading-5 tw-text-dt-information-500"
              [innerHTML]="'guideReopenInfo' | i18n"
            ></div>
          </div>
        </div>
      </div>

      <div class="tw-w-full tw-px-1 tw-pt-6">
        <div class="tw-flex tw-w-full tw-items-center tw-gap-2">
          <div class="tw-h-px tw-flex-1 tw-bg-dt-surface-sunken"></div>

          <div class="tw-text-xs tw-font-semibold tw-uppercase tw-text-dt-text-disabled">
            {{ "completed" | i18n }}
          </div>

          <div class="tw-h-px tw-flex-1 tw-bg-dt-surface-sunken"></div>
        </div>

        <div class="tw-flex tw-flex-col tw-gap-2 tw-pt-4">
          @for (task of completedTasks(); track task.id) {
            <ng-container
              *ngTemplateOutlet="taskBar; context: { task: task, isCompleted: true }"
            ></ng-container>
          }
        </div>
      </div>

      <div class="tw-w-full tw-bg-dt-surface-card tw-pt-4 tw-mt-auto">
        <div class="tw-max-w-[496px] tw-mx-auto tw-px-4">
          <button
            (click)="goToHome()"
            class="tw-w-full tw-h-[60px] tw-rounded-full tw-bg-dt-today-550 tw-text-dt-text-contrast tw-font-bold tw-text-[20px]"
          >
            {{ "goToHome" | i18n }}
          </button>
        </div>
      </div>
    </div>
  } @else {
    <!-- Default State -->
    <div
      class="tw-w-full tw-max-w-[496px] tw-mx-auto tw-flex tw-flex-col tw-gap-6 sm:tw-mt-4 sm:tw-px-0 tw-bg-dt-surface-card tw-rounded-3xl"
    >
      <!-- Tabs (hidden when `hideFilter` is true) -->
      @if (!hideFilter()) {
        <div class="tw-flex xs:tw-flex-col tw-w-full">
          <div class="tw-flex tw-w-full tw-h-[48px] tw-bg-dt-surface-page tw-rounded-3xl">
            @for (tabKey of tabs; track tabKey) {
              <div
                class="tw-flex-1 tw-flex tw-items-center tw-justify-center tw-h-full"
                [ngClass]="{
                  'tw-bg-dt-surface-card tw-border tw-border-solid tw-border-dt-border-primary tw-rounded-3xl tw-shadow-neuomorphic-subtle-minimal':
                    tabKey === 'allTasks',
                }"
              >
                <span
                  [ngClass]="
                    tabKey === 'allTasks'
                      ? 'tw-font-medium tw-text-sm tw-text-dt-text-headings'
                      : 'tw-text-sm tw-text-dt-text-secondary'
                  "
                >
                  {{ tabKey | i18n }}
                </span>
              </div>
            }
          </div>
        </div>
      }

      <!-- Tasks -->
      <div class="tw-mt-2 tw-grid tw-w-full tw-gap-4 tw-rounded-lg tw-bg-dt-surface-card tw-p-1">
        @for (task of inProgressTasks(); track task.id) {
          <ng-container
            *ngTemplateOutlet="taskBar; context: { task: task, isCompleted: false }"
          ></ng-container>
        }
      </div>

      <!-- Completed -->
      <div
        class="tw-flex tw-w-full tw-flex-col tw-gap-4 tw-rounded-lg tw-px-1 tw-py-3 tw-bg-dt-surface-card"
      >
        <!-- Divider -->
        <div class="tw-flex tw-w-full tw-items-center tw-gap-2">
          <div class="tw-h-px tw-flex-1 tw-bg-dt-surface-sunken"></div>

          <div class="tw-text-xs tw-font-semibold tw-uppercase tw-text-dt-text-disabled">
            {{ "completed" | i18n }}
          </div>

          <div class="tw-h-px tw-flex-1 tw-bg-dt-surface-sunken"></div>
        </div>

        @for (task of completedTasks(); track task.id) {
          <ng-container
            *ngTemplateOutlet="taskBar; context: { task: task, isCompleted: true }"
          ></ng-container>
        }
      </div>
    </div>
  }
}

<ng-template #taskBar let-task="task" let-isCompleted="isCompleted">
  @if (isShownTask(task)) {
    <div
      (click)="navigateToTaskPage(task)"
      class="tw-flex tw-h-full tw-w-full tw-items-center tw-gap-3 tw-rounded-2xl tw-h-[62px] tw-px-0 tw-py-2 tw-bg-dt-surface-card"
      [ngClass]="[
        task.hasRoute ? 'tw-cursor-pointer' : '',
        !isCompleted ? 'tw-bg-dt-surface-card tw-shadow-button' : '',
      ]"
    >
      <div class="tw-flex tw-h-11 tw-w-11 tw-items-center tw-justify-center tw-rounded-2xl">
        <icon
          [name]="isCompleted ? 'check-list-circle' : 'circle_with_shadow'"
          [size]="5"
          [currentColor]="'primary'"
        ></icon>
      </div>
      <div class="tw-flex tw-items-start tw-flex-1 xs:tw-flex-col tw-gap-2">
        <div
          class="tw-text-[14px] tw-font-medium"
          [ngClass]="isCompleted ? 'tw-text-dt-text-headings' : 'tw-text-dt-text-headings'"
        >
          <span class="tw-flex tw-flex-col">
            {{ task.title | i18n }}
          </span>
        </div>
        <div class="tw-text-[11px] tw-font-medium tw-text-dt-text-disabled">
          {{ task.rewardType | i18n | uppercase }}
        </div>
      </div>
      <div
        class="tw-flex tw-w-[88px] tw-h-[30px] tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-dt-surface-card tw-text-dt-text-action tw-font-bold tw-text-[14px]"
      >
        + {{ task.reward }} CrG
      </div>

      <div class="tw-h-6 tw-w-6">
        @if (task.hasRoute) {
          <icon [name]="'right-arrow'" [size]="5"></icon>
        }
      </div>
    </div>
  }
</ng-template>
